import styled from '@emotion/styled'
import { Button } from 'bold-ui'
import { SubmitButton, TextAreaField } from 'components/form'
import React from 'react'
import { Meta } from 'util/metaPath'

interface ObservacaoFormGridProps {
  name: Meta<String>
  onCancel(): any
  onSubmit(): any
}

export const ObservacaoFormGrid = (props: ObservacaoFormGridProps) => {
  const { name, onCancel, onSubmit } = props

  return (
    <FormGrid>
      <TextAreaField name={name} placeholder='Insira outras observações.' maxLength={200} />
      <Button size='small' onClick={onCancel}>
        Cancelar
      </Button>
      <SubmitButton size='small' handleSubmit={onSubmit}>
        Salvar
      </SubmitButton>
    </FormGrid>
  )
}

const FormGrid = styled.div`
  align-items: flex-start;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto auto;
  grid-gap: 1rem;
`
